import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">热门话题</h2>
        <p className="section-subtitle">剧迷最关注的热门话题标签，找到你的追剧同好</p>

        <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {topicsData.map((topic) => (
            <div
              key={topic.name}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm cursor-pointer ${topic.color} transition-transform hover:scale-105`}
            >
              <span>{topic.name}</span>
              <span className="text-xs opacity-70">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}